<script lang="ts" context="module">
  const map = {
    metrics: Metrics,
    'button-cta': ButtonCta,
    'metrics-by-variant': MetricsByVariant,
    'paragraph-by-variant': ParagraphByVariant,
    'faq-tabs': FaqTabs
  };

  export type RichTextBlocks = keyof typeof map;

  const isComponent = (block: { component: string }): block is { component: RichTextBlocks } => {
    return !!block.component && block.component in map;
  };
</script>

<script lang="ts">
  import { dev } from '$app/environment';
  import type { ComponentProps, ComponentType } from 'svelte';

  import Metrics from './metrics.svelte';
  import ButtonCta from '../blocks/deprecated/button-cta.svelte';
  import MetricsByVariant from './metrics-by-variant.svelte';
  import ParagraphByVariant from './paragraph-by-variant.svelte';
  import FaqTabs from './faq-tabs.svelte';

  type ComponentRestProps =
    | Omit<ComponentProps<Metrics>, 'class' | 'block'>
    | Omit<ComponentProps<MetricsByVariant>, 'class' | 'block'>
    | Omit<ComponentProps<ButtonCta>, 'class' | 'block'>
    | Omit<ComponentProps<ParagraphByVariant>, 'class' | 'block'>;

  export let block: { component: string };
  export let richTextBlockProps: ComponentRestProps | undefined = undefined;

  const component: ComponentType | null = isComponent(block) ? map[block.component] : null;

  if (!component && dev) {
    console.error('Uncaught component', block.component);
  }
</script>

{#if component}
  <svelte:component this={component} {block} {...richTextBlockProps} {...$$restProps} />
{/if}
